<template>
  <div class="col-12 col-md-6 col-lg-12 col-xxl-6">
    <div class="justify-content-between d-flex">
      <h2>Poznámky</h2>
      <button type="button"
        class="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#addNote"
        @click="resetMessage()"
        v-if="$store.getters.hasPerm('add_note')">
        <icon icon="Plus" />
      </button>
    </div>
    <ul>
      <li v-if="notes.length === 0" class="my-2">Žádné poznámky</li>
      <li v-if="$store.getters.hasPerm('view_note')" v-for="(note, index) in notes" :key="index" class="my-2" :class="{ 'pinned': note.pinned }">
        <strong>
          {{ note.modified_at }}
        </strong>:
        {{ note.message }}
        {{ note.modified_at !== note.created_at ? `(poznámka z ${note.created_at}, editováno)` : '' }}
        <br />
        <button type="button"
          class="btn btn-sm btn-outline-secondary ms-auto"
          data-bs-toggle="modal"
          data-bs-target="#editNote"
          @click="setMessage(note)"
          v-if="$store.getters.hasPerm('change_note')">
          Editovat
        </button>&nbsp;
        <!-- <button type="button"
          class="btn btn-sm btn-outline-secondary ms-auto"
          data-bs-toggle="modal"
          data-bs-target="#deleteNote"
          @click="setMessage(note)"
          v-if="$store.getters.hasPerm('delete_note')">
          Smazat
        </button>&nbsp; -->
        <button type="button"
          class="btn btn-sm btn-outline-secondary ms-auto"
          @click="pin(note)"
          v-if="$store.getters.hasPerm('change_note')">
          <icon v-if="!note.pinned" icon="Pin" />
          <icon v-else-if="note.pinned" icon="PinOff" />
        </button>
      </li>
    </ul>
  </div>
  <Popup ref="newNote"
    :header="'Nová poznámka'"
    :editable="true"
    id="addNote"
    @save-data="postNote"
    v-if="$store.getters.hasPerm('add_note')"
  />
  <Popup ref="existingNote"
    :header="'Editovat poznámku'"
    :body="message"
    :editable="true"
    id="editNote"
    @save-data="editNote"
    v-if="$store.getters.hasPerm('change_note')"
  />
  <!-- <Popup
    :header="'Opravdu smazat poznámku?'"
    :body="message"
    :button="'Smazat'"
    id="deleteNote"
    @save-data="deleteNote"
    v-if="$store.getters.hasPerm('delete_note')"
  /> -->
</template>


<script>
import Popup from '@/components/Popup.vue';

export default {
  emits: ['reload-data'],
  components: {
    Popup
  },
  props: {
    memberId: {
      required: true
    }
  },
  data() {
    return {
      notes: [],
      message: "",
      id: "",
      pinned: false
    }
  },
  methods: {
    setMessage(note) {
      this.$refs.existingNote.setInput(note.message)
      this.message = note.message
      this.id = note.id
      this.pinned = note.pinned
    },
    resetMessage() {
      this.$refs.newNote.setInput("")
    },
    postNote: function (input) {
      this.$store.getters.api.post("/member/" + this.memberId + "/notes", { message: input }).then(function (response) {
        this.loadData(); // Reload data to display the newly created note
      }.bind(this))
      .catch(function (error) {
        alert("Nepodařilo se vložit poznámku. Opakujte akci, nebo kontaktujte správce systému. Chyba: " + error.message);
      });
    },
    editNote: function (input) {
      this.$store.getters.api.put("/member/" + this.memberId + "/notes", { message: input, id: this.id, pinned: this.pinned }).then(function (response) {
        this.loadData(); // Reload data to display the edited note
      }.bind(this))
      .catch(function (error) {
        alert("Nepodařilo se uložit změny. Opakujte akci, nebo kontaktujte správce systému. Chyba: " + error.message);
      });
    },
    pin: function (note) {
      if (note.pinned) {
        this.pinned = false;
      } else {
        this.pinned = true;
      }
      this.id = note.id;
      this.editNote(note.message);
    },
    // deleteNote: function () {
    //   const memberId = this.$route.params.id;

    //   this.$store.getters.api.delete("/member/" + memberId + "/notes/" + this.id).then(function (response) {
    //     this.loadData(); // Reload data to display the deleted note
    //   }.bind(this))
    //   .catch(function (error) {
    //     alert("Nepodařilo se smazat poznámku. Opakujte akci, nebo kontaktujte správce systému. Chyba: " + error.message);
    //   });
    // },
    loadData: function () {
      this.$store.getters.api.get("/member/" + this.memberId + "/notes").then(function (response) {
        this.notes = response.data.items;
      }.bind(this));
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/scss/abstracts/_variables.scss";

h2 {
  font-size: 24px;
}

.pinned {
  background-color: $background-green;
  border: 2px solid $yellow-light;
  padding: 0.7rem;
  border-radius: 0.5rem;
}

.btn-outline-secondary:hover {
  .icon {
    stroke: #fff;
    transition: stroke 0.15s ease-in-out;
  }
}

.btn-outline-secondary:active, .btn-outline-secondary:target {
  .icon {
    stroke: #fff;
    transition: stroke 0.15s ease-in-out;
  }
}
</style>